export interface InspirationalQuote {
  es: string;
  en: string;
  authorEs: string;
  authorEn: string;
}

// A mix of quotes about learning, knowledge, motivation and geography —
// shown once per finished quiz, translated to the app's active language.
export const inspirationalQuotes: InspirationalQuote[] = [
  {
    es: "Presta atención a qué le prestas atención.",
    en: "Pay attention to what you pay attention to.",
    authorEs: "Anónimo",
    authorEn: "Unknown",
  },
  {
    es: "Vive como si fueras a morir mañana. Aprende como si fueras a vivir para siempre.",
    en: "Live as if you were to die tomorrow. Learn as if you were to live forever.",
    authorEs: "Mahatma Gandhi",
    authorEn: "Mahatma Gandhi",
  },
  {
    es: "Invertir en conocimientos produce siempre los mejores beneficios.",
    en: "An investment in knowledge always pays the best interest.",
    authorEs: "Benjamin Franklin",
    authorEn: "Benjamin Franklin",
  },
  {
    es: "Cualquiera que para de aprender se hace viejo, tenga veinte u ochenta años. Cualquiera que sigue aprendiendo permanece joven.",
    en: "Anyone who stops learning is old, whether at twenty or eighty. Anyone who keeps learning stays young.",
    authorEs: "Henry Ford",
    authorEn: "Henry Ford",
  },
  {
    es: "El conocimiento no sirve de nada a menos que lo pongas en práctica.",
    en: "Knowledge is of no value unless you put it into practice.",
    authorEs: "Antón Chéjov",
    authorEn: "Anton Chekhov",
  },
  {
    es: "La mente es como un paracaídas: sólo funciona si se abre.",
    en: "The mind is like a parachute: it only works if it's open.",
    authorEs: "Albert Einstein",
    authorEn: "Albert Einstein",
  },
  {
    es: "Empieza por hacer lo necesario, luego haz lo posible y de pronto estarás haciendo lo imposible.",
    en: "Start by doing what's necessary, then do what's possible, and suddenly you are doing the impossible.",
    authorEs: "San Francisco de Asís",
    authorEn: "Francis of Assisi",
  },
  {
    es: "No estudio por saber más, sino por ignorar menos.",
    en: "I do not study to know more, but to be ignorant of less.",
    authorEs: "Sor Juana Inés de la Cruz",
    authorEn: "Sor Juana Inés de la Cruz",
  },
  {
    es: "No hay barrera, cerradura, ni cerrojo que puedas imponer a la libertad de mi mente.",
    en: "No barrier, no lock, no bolt that you can set upon the freedom of my mind.",
    authorEs: "Virginia Woolf",
    authorEn: "Virginia Woolf",
  },
  {
    es: "Usted no debe tener miedo en la vida, sólo debe entender. Ahora es el momento de entender más, para que podamos temer menos.",
    en: "Nothing in life is to be feared, it is only to be understood. Now is the time to understand more, so that we may fear less.",
    authorEs: "Marie Curie",
    authorEn: "Marie Curie",
  },
  {
    es: "Un niño, un maestro, un libro y una pluma pueden cambiar el mundo. La educación es la única solución.",
    en: "One child, one teacher, one book and one pen can change the world. Education is the only solution.",
    authorEs: "Malala Yousafzai",
    authorEn: "Malala Yousafzai",
  },
  {
    es: "Lee y conducirás, no leas y serás conducido.",
    en: "Read, and you will lead; do not read, and you will be led.",
    authorEs: "Santa Teresa de Jesús",
    authorEn: "Teresa of Ávila",
  },
  {
    es: "Las bibliotecas públicas son espacios democráticos donde se pueden nivelar las desigualdades.",
    en: "Public libraries are democratic spaces where inequalities can be leveled out.",
    authorEs: "Irene Vallejo",
    authorEn: "Irene Vallejo",
  },
  {
    es: "El proceso en sí mismo es su recompensa.",
    en: "The process itself is the reward.",
    authorEs: "Amelia Earhart",
    authorEn: "Amelia Earhart",
  },
  {
    es: "Lo más difícil es decidirse a actuar; lo demás es solo perseverancia.",
    en: "The most difficult thing is the decision to act; the rest is merely tenacity.",
    authorEs: "Amelia Earhart",
    authorEn: "Amelia Earhart",
  },
  {
    es: "Un mapa te dice dónde has estado, dónde estás y adónde vas.",
    en: "A map tells you where you've been, where you are, and where you're going.",
    authorEs: "Peter Greenaway",
    authorEn: "Peter Greenaway",
  },
  {
    es: "Sin geografía no se llega a ninguna parte.",
    en: "Without geography, you're nowhere.",
    authorEs: "Jimmy Buffett",
    authorEn: "Jimmy Buffett",
  },
  {
    es: "La geografía es la asignatura que tiene la clave de nuestro futuro.",
    en: "Geography is the subject which holds the key to our future.",
    authorEs: "Michael Palin",
    authorEn: "Michael Palin",
  },
  {
    es: "El estudio de la geografía es más que solo memorizar lugares en un mapa. Se trata de comprender la complejidad de nuestro mundo.",
    en: "The study of geography is more than just memorizing places on a map. It's about understanding the complexity of our world.",
    authorEs: "Barack Obama",
    authorEn: "Barack Obama",
  },
  {
    es: "La unidad de todas las ciencias se encuentra en la geografía.",
    en: "The unity of all the sciences is to be found in geography.",
    authorEs: "John Dewey",
    authorEn: "John Dewey",
  },
  {
    es: "El hombre es un producto de la superficie de la Tierra.",
    en: "Man is a product of the earth's surface.",
    authorEs: "Ellen Churchill Semple",
    authorEn: "Ellen Churchill Semple",
  },
  {
    es: "La característica más importante de las llanuras es su poder para facilitar cada fase de la historia.",
    en: "The most significant thing about the plain is its uniform power to facilitate every phase of history.",
    authorEs: "Ellen Churchill Semple",
    authorEn: "Ellen Churchill Semple",
  },
  {
    es: "El espacio no es una superficie plana sobre la que caminamos; es la simultaneidad de historias hasta ahora vividas.",
    en: "Space is not a flat surface across which we walk; it is a simultaneity of stories-so-far.",
    authorEs: "Doreen Massey",
    authorEn: "Doreen Massey",
  },
  {
    es: "Los lugares están hechos de relaciones sociales particulares, y estas relaciones siempre implican poder y exclusión.",
    en: "Places are made through particular sets of social relations, and these relations always entail relations of power and exclusion.",
    authorEs: "Linda McDowell",
    authorEn: "Linda McDowell",
  },
  {
    es: "La educación es el arma más poderosa que podés usar para cambiar el mundo.",
    en: "Education is the most powerful weapon which you can use to change the world.",
    authorEs: "Nelson Mandela",
    authorEn: "Nelson Mandela",
  },
  {
    es: "Dime y lo olvido, enséñame y lo recuerdo, involúcrame y lo aprendo.",
    en: "Tell me and I forget, teach me and I remember, involve me and I learn.",
    authorEs: "Benjamin Franklin",
    authorEn: "Benjamin Franklin",
  },
  {
    es: "En algún lugar, algo increíble espera ser descubierto.",
    en: "Somewhere, something incredible is waiting to be known.",
    authorEs: "Carl Sagan",
    authorEn: "Carl Sagan",
  },
  {
    es: "La educación cambia a las personas. Las personas cambian el mundo.",
    en: "Education changes people. People change the world.",
    authorEs: "Paulo Freire",
    authorEn: "Paulo Freire",
  },
  {
    es: "Aprender nunca agota la mente.",
    en: "Learning never exhausts the mind.",
    authorEs: "Leonardo da Vinci",
    authorEn: "Leonardo da Vinci",
  },
  {
    es: "El que se atreve a enseñar, nunca debe dejar de aprender.",
    en: "He who dares to teach must never cease to learn.",
    authorEs: "John Cotton Dana",
    authorEn: "John Cotton Dana",
  },
];

export const getRandomQuote = (): InspirationalQuote =>
  inspirationalQuotes[Math.floor(Math.random() * inspirationalQuotes.length)];
